import {
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER,
  DIRECT_DEBIT_ACCOUNT_BANK_CODE,
  DIRECT_DEBIT_ACCOUNT_BANK_NAME,
  DIRECT_DEBIT_ACCOUNT_CITY,
  DIRECT_DEBIT_ACCOUNT_COUNTRY_CODE,
  DIRECT_DEBIT_ACCOUNT_STATE,
  DIRECT_DEBIT_ACCOUNT_STREET_NAME,
  DIRECT_DEBIT_ACCOUNT_STREET_NUMBER,
  DIRECT_DEBIT_ACCOUNT_ZIP_CODE,
} from '@modifi/plugin-onboarding'

export const DIRECT_DEBIT_ACCOUNT_INPUT_FIELD_NAMES: string[] = [
  DIRECT_DEBIT_ACCOUNT_BANK_NAME,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER,
  DIRECT_DEBIT_ACCOUNT_BANK_CODE,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER,
  DIRECT_DEBIT_ACCOUNT_ZIP_CODE,
  DIRECT_DEBIT_ACCOUNT_CITY,
  DIRECT_DEBIT_ACCOUNT_STREET_NUMBER,
  DIRECT_DEBIT_ACCOUNT_STREET_NAME,
  DIRECT_DEBIT_ACCOUNT_COUNTRY_CODE,
  DIRECT_DEBIT_ACCOUNT_STATE,
]

export const FIELD_NAME_TO_PROPERTY_NAME_MAPPING: Record<string, string> = {}
